import React from 'react';
import styled from 'styled-components';
import { useAuth } from 'react-oidc-context';
import { FormattedMessage } from 'react-intl';

const Text = styled.a`
    color: white;
    text-align: right;
    z-index: 2;
    text-decoration: underline;
    margin: 0;
    transition: all 0.25s;
    width: 100%;

    @media (min-width: 930px) {
        text-align: center;
    }

    &:hover, &:focus {
        cursor: pointer;
        color: var(--secondary-2);
    }
`;

export function Logout() {
    const auth = useAuth();

    return (
        <Text
            href="#"
            onClick={(e) => {
                e.preventDefault();
                auth.signoutPopup({ popupWindowFeatures: { width: 400, height: 400 } });
            }}>
            <FormattedMessage id={`LOGOUT`} />
        </Text>
    );
}
